import {Link} from 'react-router-dom';
import React from 'react';
import {UserContext} from '../../utils/usercontext';

import './css/sidemenu.css';

export default class DJAreaSideMenu extends React.Component {
	static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {};
  };
  
  async componentDidMount() {
	}

	componentWillUnmount() {
	}

	render() {
		const user = this.context;
		return (
			<div className="djarea-sidemenu-inner">
				<ul>
					<li><Link to="/djarea" className={window.location.pathname==='/djarea'?'sidemenu-active':''}>DJ Area</Link></li>
					{(user.user?.admin?.part_admin_access || Date.now()/1000 > 1727740800) &&
						<li><Link to="/djarea/competition" className={window.location.pathname==='/djarea/competition'?'sidemenu-active':''}>Competition</Link></li>
					}
					<li><Link to="/djarea/connection" className={window.location.pathname==='/djarea/connection'?'sidemenu-active':''}>Connection Details</Link></li>
					<li><Link to="/djarea/test" className={window.location.pathname==='/djarea/test'?'sidemenu-active':''}>Test Centre</Link></li>
					<li><Link to="/djarea/files" className={window.location.pathname==='/djarea/files'?'sidemenu-active':''}>Downloads Drops Jingles</Link></li>
					<li><Link to="/djarea/templates" className={window.location.pathname==='/djarea/templates'?'sidemenu-active':''}>OBS Templates</Link></li>
					<li><Link to="/djarea/members" className={window.location.pathname==='/djarea/members'?'sidemenu-active':''}>Members</Link></li>
					<li><Link to="/djarea/socials" className={window.location.pathname==='/djarea/socials'?'sidemenu-active':''}>Socials</Link></li>
					<li><Link to="/djarea/posters" className={window.location.pathname==='/djarea/posters'?'sidemenu-active':''}>Posters</Link></li>
					<li><Link to="/djarea/statistics" className={window.location.pathname==='/djarea/statistics'?'sidemenu-active':''}>Statistics</Link></li>
					<li><Link to="/djarea/logs" className={window.location.pathname==='/djarea/logs'?'sidemenu-active':''}>Schedule Logs</Link></li>
				</ul>
			</div>
		);
	}
}
